import { useCallback, useState } from 'react';
import {
  ConnectComponentsProvider,
  ConnectCapitalFinancing,
  ConnectCapitalFinancingPromotion,
} from '@stripe/react-connect-js';
import { FinancingProductType } from '@stripe/connect-js';
import { Box } from '@mui/material';
import PageLayout from '../components/global/PageLayout';
import useUser from '../hooks/global/useUser';
import PageLoading from '../components/global/PageLoading';
import { userHasAccessToCapital } from '../helpers/capital';
import useConnectCapital from '../hooks/capital/useConnectCapital';

export default function CapitalPage() {
  const { user } = useUser();
  const connectInstance = useConnectCapital();

  const [isLoadingOffers, setIsLoadingOffers] = useState(true);
  const [isLoadingFinancings, setIsLoadingFinancings] = useState(true);
  const [hasFinancingOffers, setHasFinancingOffers] = useState(false);
  const [hasFinancings, setHasFinancings] = useState(false);

  const handleFinancingOfferLoaded = useCallback(
    ({ productType }: FinancingProductType) => {
      setHasFinancingOffers(
        productType === 'standard' || productType === 'refill',
      );
      setIsLoadingOffers(false);
    },
    [],
  );

  const handleFinancingsLoaded = useCallback(({ total }: { total: number }) => {
    setHasFinancings(total > 0);
    setIsLoadingFinancings(false);
  }, []);

  const isLoading = isLoadingOffers || isLoadingFinancings;
  const hasNothing = !isLoading && !hasFinancingOffers && !hasFinancings;
  const renderFinancingPromotion = hasFinancingOffers || hasNothing;
  const renderFinancing = hasFinancings;

  return (
    <PageLayout
      title="Porter Capital"
      guard={{
        isAllowed: userHasAccessToCapital(user),
      }}>
      <>
        {(!connectInstance || isLoading) && <PageLoading />}
        {!!connectInstance && (
          <ConnectComponentsProvider connectInstance={connectInstance}>
            <Box display={renderFinancingPromotion ? 'block' : 'none'}>
              <ConnectCapitalFinancingPromotion
                layout={renderFinancing ? 'banner' : 'full'}
                onEligibleFinancingOfferLoaded={handleFinancingOfferLoaded}
              />
            </Box>
            <Box display={renderFinancing ? 'block' : 'none'}>
              <ConnectCapitalFinancing
                onFinancingsLoaded={handleFinancingsLoaded}
              />
            </Box>
          </ConnectComponentsProvider>
        )}
      </>
    </PageLayout>
  );
}
